import { Component, OnInit } from '@angular/core';
import {AnalyticsService} from '../components/analytics-service/analytics.service';

@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.scss']
})
export class PublicationsComponent implements OnInit {

  constructor(private analyticsService: AnalyticsService) {
    this.analyticsService.emitEvent(
      'Page visit',
      'Publications'
    );
  }
  ngOnInit() {
  }

}
